import {
  CustomerWidgetState,
  GetCustomerWidgetStateFn,
} from "@redotech/redo-model/customer-widget/customer-widget";
import {
  getLocalStorageWithExpiry,
  setLocalStorageWithExpirySeconds,
} from "../utils/local-storage-wrapper";
import {
  CONCIERGE_CONVERSATION_LOCAL_STORAGE_KEY,
  CONCIERGE_INITIAL_MESSAGES_KEY,
  CONCIERGE_PROMPT_KEY,
  ConciergePromptEvent,
  REDO_CONCIERGE_HASH,
} from "../utils/shared-conf";

export function externallyAddConciergeCustomerMessage(message: string) {
  if (
    (globalThis as any).getCustomerWidgetState?.() ===
    CustomerWidgetState.CONCIERGE_MESSAGING
  ) {
    const windowEvent = new ConciergePromptEvent(message);
    dispatchEvent(windowEvent);
  } else {
    setLocalStorageWithExpirySeconds(CONCIERGE_PROMPT_KEY, message, 60);
    location.hash = REDO_CONCIERGE_HASH;
  }
}

export function setGetCustomerWidgetState(
  window: Window,
  currentState: CustomerWidgetState,
) {
  const getCustomerWidgetState: GetCustomerWidgetStateFn = () => currentState;
  (window as any).getCustomerWidgetState = getCustomerWidgetState;
}

export function externallyAddInitialConciergeMessages(
  initialMessages: string[],
) {
  setLocalStorageWithExpirySeconds(
    CONCIERGE_INITIAL_MESSAGES_KEY,
    initialMessages,
    60,
  );
  location.hash = REDO_CONCIERGE_HASH;
}

export const getConciergeConversationIdLocalStorage = (): string | null => {
  return getLocalStorageWithExpiry(CONCIERGE_CONVERSATION_LOCAL_STORAGE_KEY, {
    returnNullIfMissingExpiry: true,
  });
};
